import VideoPlayer from './template';
export default VideoPlayer;
